import { render } from "./DateFormat.vue?vue&type=template&id=f708df0c"
import script from "./DateFormat.vue?vue&type=script&lang=js"
export * from "./DateFormat.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__